var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      attrs: {
        "data-cy": `${_vm.name}-btn-delete`,
        href: "javascript:void(0);",
      },
    },
    [
      _c("b-img", {
        staticClass: "no-checkbox cls-img-btn ml-2",
        attrs: { id: "delete-" + _vm.id, src: "/assets/icons/trash.svg" },
        on: {
          click: function ($event) {
            return _vm.onClick()
          },
        },
      }),
      _vm._v(" "),
      _c("b-tooltip", {
        attrs: {
          target: "delete-" + _vm.id,
          placement: "bottom",
          title: _vm.$t("tool-tips.delete"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }